import * as _ from "lodash";
import { useRef } from "react";

export default function useUniqueId(): string {
    const id = useRef(_.uniqueId())

    return id.current;
}